<template>
  <ConfiguratorOverlay class="px-1">
    <div class="col-span-full">
      <span
        v-if="extraOptions.request.isLoading"
        class="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <SpinnerIcon :size="'w-20 h-20'" />
      </span>

      <div v-else class="mx-auto">
        <ProductOptionCategory
          v-for="(
            productOptionCategory, index
          ) in extraOptionsStore.productOptionsCategories"
          :key="`product_option_category_${index}`"
          :category="productOptionCategory"
        />

        <ConfiguratorExtraOptionsOverview />
      </div>
    </div>
  </ConfiguratorOverlay>
</template>

<script setup lang="ts">
import SpinnerIcon from '@/components/Icons/SpinnerIcon.vue';
import ProductOptionCategory from '@/components/ProductOptions/ProductOptionCategory.vue';
import { useExtraOptions } from '@/composables/UseExtraOptions';
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import ConfiguratorExtraOptionsOverview from '../Configurator/ConfiguratorExtraOptionsOverview.vue';
import ConfiguratorOverlay from '../Configurator/ConfiguratorLayout/ConfiguratorOverlay.vue';

const extraOptions = useExtraOptions();
const extraOptionsStore = useExtraOptionsStore();
</script>
